import { PictureAsPdf } from "@mui/icons-material";
import { alpha, Box, Chip } from "@mui/material";
import { AiInteractionFile } from "src/api/types";
import { theme } from "src/assets/theme";

interface Props {
  file: AiInteractionFile;
}

const FileView = ({ file }: Props) => {
  return file.mime_type === "application/pdf" ? (
    <Chip label={file.file_name} icon={<PictureAsPdf />} />
  ) : (
    <Box
      component="img"
      src={file.signedUrl}
      alt={file.file_name}
      sx={{
        maxWidth: "100%",
        maxHeight: 150,
        borderRadius: "10px",
        objectFit: "cover",
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
      }}
    />
  );
};

export default FileView;
